export enum PostKey {
  POSTS = 'posts',
  POSTS_INFINITE = 'postsInfinite',
}
